import React, { FunctionComponent } from 'react'
import styles from './SortIndicator.module.sass'
import ArrowUpIcon from 'files/arrow/arrow-up.svg'
import ArrowDownIcon from 'files/arrow/arrow-down.svg'
import clsx from 'clsx'
import { SortDirection } from '../../../../../constants/direction'

interface Props {
    value?: SortDirection,
}

const SortIndicator: FunctionComponent<Props> = props => {
    return <div className={styles.direction}>
        <ArrowUpIcon className={clsx({[styles.active]: props.value === SortDirection.ASC})}/>
        <ArrowDownIcon className={clsx({[styles.active]: props.value === SortDirection.DESC})}/>
    </div>
}

export default SortIndicator